import { ResourceStore } from 'src/stores/ResourceStore/ResourceStore';

export const JahezComissionTypeResourceStore = new ResourceStore(
    'data/jahezComissionType.json',
);
